import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=28eb218e&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=28eb218e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb218e",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
